export function fetchImage(path) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = (e) => {
      console.log(e)
      return reject(e)
    }
    img.src = path
  })
}

export function fetchImages(paths) {
  const promises = paths.map((path) => fetchImage(path))
  return Promise.all(promises)
}
